/**
 * Do not edit directly!
 * Read more: https://ink.carta.com/contributing/css-styleguide/#tokens
 */

export const blockquoteTokens = {
  BorderColorDefault: '#ebecec',
  BorderStyleDefault: 'solid',
  BorderWidthDefault: '8px',
  SpacingHorizontalLeft: '4px',
  SpacingHorizontalRight: '12px',
} as const;
